// extracted by mini-css-extract-plugin
export var avatarContainer = "_al-0";
export var avatarTypingWave = "_al-i";
export var gray = "_al-f";
export var green = "_al-c";
export var icon = "_al-9";
export var image = "_al-1";
export var lg = "_al-6";
export var md = "_al-5";
export var presenceDot = "_al-b";
export var red = "_al-d";
export var sm = "_al-4";
export var status = "_al-a";
export var typingDot = "_al-h";
export var typingPill = "_al-g";
export var xl = "_al-7";
export var xs = "_al-3";
export var xxl = "_al-8";
export var xxs = "_al-2";
export var yellow = "_al-e";